const firebaseConfig = {
  apiKey: "AIzaSyCeY0v9XehHwn73V2Qpg0zRpmKQIwh1Ews",
  authDomain: "labelle-club.firebaseapp.com",
  projectId: "labelle-club",
  storageBucket: "labelle-club.appspot.com",
  messagingSenderId: "136386081772",
  appId: "1:136386081772:web:1332fa2940c68551a886c9",
  measurementId: "G-TT6TF0TCD2"
}
export default firebaseConfig 